import React, { useContext, useEffect, useRef, useState } from 'react'
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import Slider from "react-slick";
import { Field, Form, Formik } from 'formik';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { VehicleContext } from '../Components/Context/VehicleContext';
import Fancybox from '../Components/Common/Fancybox';
import { ErrorMessage } from 'formik';
import { getImages, getMakeImages } from '../Components/Common/const';
import ReCAPTCHA from 'react-google-recaptcha';

const Vdp = () => {
    const navigate = useNavigate();
    const optionsVdp = {
        responsive: {
            0: {
                items: 2,
                margin: 10
            },
            600: {
                items: 2,
                margin: 20
            },
            768: {
                items: 3,
                margin: 25
            },
            1000: {
                items: 3,
                margin: 25
            }
        },
    };

    const queryParameters = new URLSearchParams(window.location.search);
    const vehicleVIN = queryParameters.get("vin");
    // console.log("vehicleVIN", vehicleVIN)

    const { getVehicleData, vehiclesByVIN, numberFormatter, priceFormatter, submitContactForm } = useContext(VehicleContext);
    const recaptchaRef = React.useRef();



    const [vehicleData, setVehicleData] = useState({});

    const [vehicleExist, setVehicleExist] = useState(false);

    useEffect(() => {
        getVehicleData();
    }, [])

    useEffect(() => {
        if (vehicleVIN && vehiclesByVIN && vehicleVIN in vehiclesByVIN) {
            var vehicle_data = vehiclesByVIN[vehicleVIN];
            const split_index = Math.ceil((vehicle_data.images.length - 1) / 2);
            console.log(vehicle_data, split_index);

            if (split_index > 0) {
                //var gallery_images = vehicle_data.images.slice(1).reduce(function (rows, key, index) {
                //    return (index % 2 == 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows;
                //}, []);
                console.log(vehicle_data.images.length - 1, split_index);
                var gallery_images = vehicle_data.images.slice(vehicle_data.manual_entry ? 0 : 1).reduce(function (rows, key, index) {
                    return (index % 2 == 0 || vehicle_data.images.length - 1 <= 3 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows;
                }, []);
                vehicle_data.gallery_images = gallery_images;
            } else
                vehicle_data.gallery_images = vehicle_data.images.slice(vehicle_data.manual_entry ? 0 : 1);
            console.log(vehicle_data);
            setVehicleData(vehicle_data);
            setVehicleExist(true);
        }
    }, [vehicleVIN, vehiclesByVIN]);

    //  UseLocation
    const location = useLocation();
    useEffect(() => {
        // Function to scroll to the section
        const scrollToSection = () => {
            const hash = location.hash;
            if (hash) {
                const element = document.querySelector(hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }
        };

        // Scroll after a slight delay to ensure DOM updates are complete
        const timeoutId = setTimeout(scrollToSection, 2000);

        // Clean up the timeout if the component unmounts
        return () => clearTimeout(timeoutId);
    }, [vehicleData]);

    // Is Loaded
    const [isDataLoaded, setIsDataLoaded] = useState(true);
    useEffect(() => {
        setTimeout(() => {
            setIsDataLoaded(false);
        }, 2000);
    }, [vehicleData]);

    // If Vin not Found navigate page 
    useEffect(() => {
        if (!vehicleVIN || !vehiclesByVIN) {
            return;
        }

        // Case-insensitive match
        const match = Object.values(vehiclesByVIN).find(
            (v) => v.vin.toLowerCase() === vehicleVIN.toLowerCase()
        );

        if (!match) {
            navigate("/inventory");
        }
    }, [vehicleVIN, vehiclesByVIN, navigate]);

    // End If Vin not Found navigate page 

    const [tooltipVisible, setTooltipVisible] = useState(false);
    const handleCopy = () => {
        const textArea = document.createElement('textarea');
        textArea.value = vehicleData.vin;
        textArea.style.position = 'absolute';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
            showTooltip();
        } catch (err) {
            console.error('Failed to copy text:', err);
        }
        document.body.removeChild(textArea);
    };

    const showTooltip = () => {
        setTooltipVisible(true);
        setTimeout(() => {
            setTooltipVisible(false);
        }, 2000);
    };


    const scrollToInquire = () => {
        const section = document.getElementById('gotAQuestion');
        section.scrollIntoView({ behavior: 'smooth' });
    };
    // console.log("vehicleData", vehicleData)
    const sectionRef = useRef(null);
    const scrollToSection = () => {
        sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };
    // Mobile view condition
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [showAll, setShowAll] = useState(false);
    const visibleItems = showAll ? vehicleData?.descriptions : vehicleData?.descriptions?.slice(0, 6);
    const galleryRef = useRef(null);
    const openGallery = () => {
        const flatImages = vehicleData?.gallery_images?.flat();
        const items = flatImages.map((src) => ({ src, type: "image" }));

        NativeFancybox.show(items);
    };

    var srpCarSlider = {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        dots: false,
        infinite: vehicleData?.gallery_images > 3
    };
    // Read More

    const [isExpanded, setIsExpanded] = useState(false);
    const maxChars = 420;
    const toggleReadMore = () => {
        setIsExpanded(prev => !prev);
    };
    // if (vehicleData.description?.length <= maxChars) {
    //     return <div dangerouslySetInnerHTML={{ __html: vehicleData.description }} />;
    // }
    const renderHTML = (html) => ({ __html: html });
    const shortText = vehicleData.description?.substring(0, maxChars);
    return (
        <>
            {vehicleExist ?
                <>
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey="6LfuE4MrAAAAAJdFHXLQK_ktBMzfl8C9I5fpmiJU" // Replace with your actual site key
                        size="invisible"
                    />
                    <section className='vdp-wrap'>
                        <div className='container mxw-1366'>
                            <section className='vdp-banner-wrap'>
                                <div className='d-md-flex vdp-banner-flex align-items-center'>
                                    <div className='w-50 wow reveal fadeInUp text-center'>

                                        {vehicleData.vdp_hero_image ?
                                            <img src={vehicleData.vdp_hero_image} alt='hero'
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = getImages(`vdp_banner_coming_soon.webp`);
                                                }}
                                            />
                                            :
                                            <div className='py-3'>
                                                <img src={getImages('vdp_banner_coming_soon.webp')} alt='coming soon' />
                                            </div>
                                        }
                                    </div>
                                    <div className='w-50 ps-md-4 wow reveal fadeInUp'>
                                        <div className='d-flex align-items-center mb-2 brand-flex'>
                                            <div className='brand-logo'>
                                                <img src={getImages(`logos/${vehicleData.make}.png`)} />
                                                {/* <img
                                                    src={getMakeImages(`${vehicleData.make}.png`)}
                                                    alt={vehicleData.make}
                                                /> */}
                                            </div>
                                            <div className='brand-name ps-3 text-uppercase'>
                                                {vehicleData.make}
                                            </div>
                                        </div>
                                        <h1 className='vdp-md-title mt-3 mb-3 mb-md-4'>
                                            {vehicleData.year} {vehicleData.model} {vehicleData.trim}
                                        </h1>
                                        <div className='d-md-flex align-items-center justify-content-between vdp-banner-info'>
                                            <div>
                                                <div className='d-flex align-items-center justify-content-between mb-3 mb-md-0'>
                                                    <div className='sm-title mob-vdp-miles'>
                                                        {priceFormatter(vehicleData.price, true)}
                                                    </div>
                                                    <div className='sm-title mob-vdp-miles ms-5'>
                                                        {numberFormatter(vehicleData.mileage, false, false)} mi
                                                    </div>
                                                    {/* <div className='d-md-none'>
                                                        <div className='d-inline-flex mb-md-4 price-sec2 mob-price-sec2'>
                                                            {vehicleData.price > 0 && <span className='d-none d-md-block xs-title pe-md-2'>Price</span>}
                                                            <span className='vdp-lg-title mb-2'>
                                                                {numberFormatter(vehicleData.price, true)}
                                                            </span>
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div className='text-end'>
                                                {/* <div className='d-inline-flex align-items-center d-none d-md-block mb-0 price-sec2'>
                                                    {vehicleData.price > 0 && <span className='xs-title pe-2'>Price</span>}
                                                    <span className='vdp-lg-title'>
                                                        {numberFormatter(vehicleData.price, true)}
                                                    </span>
                                                </div> */}
                                                <div className='pt-md-2'>
                                                    <button className='transparent-btn inquire-btn' type='button' onClick={scrollToSection}>Inquire</button>
                                                </div>
                                            </div>
                                        </div>
                                                
                                            <div className={isMobile ? "text-center mt-md-2" : "text-end mt-md-2"}>
                                                <a href={'http://www.carfax.com/VehicleHistory/p/Report.cfx?partner=DVW_1&vin=' + vehicleData.vin} target="_blank">
                                                    <img src={getImages(isMobile ? 'carfax-tag-new.png' : 'carfax-tag.png')} alt='carfax' />
                                                </a>
                                            </div>
                                    </div>
                                </div>
                            </section>
                            {vehicleData?.descriptions?.length > 0 &&
                                <section className='vdp-list-wrap'>
                                    {isMobile ?
                                        <div className='vdpl-flex wow reveal fadeInUp'>
                                            <ul className="vdp-list">
                                                {visibleItems.map((item, index) => (
                                                    <li key={index}>{item}</li>
                                                ))}
                                            </ul>
                                            <button className="view-more-btn" onClick={() => setShowAll(!showAll)}>
                                                {!showAll ? 'View More' : 'View Less'}
                                            </button>
                                        </div>
                                        :
                                        <div className='d-flex vdpl-flex vdpl-desktop-flex wow reveal fadeInUp'>
                                            <ul className='vdp-list'>
                                                {vehicleData.descriptions.filter((item, index) => index < vehicleData.descriptions.length / 2).map((item, index) => (
                                                    <li key={index}>{item}</li>
                                                ))}
                                            </ul>
                                            <ul className='vdp-list'>
                                                {vehicleData.descriptions.filter((item, index) => index >= vehicleData.descriptions.length / 2).map((item, index) => (
                                                    <li key={index}>{item}</li>
                                                ))}
                                            </ul>
                                        </div>}
                                </section>
                            }
                        </div>
                        {vehicleData.gallery_images.length > 0 &&
                            <section className='vdp-gallery-wrap'>
                                <div className='container mxw-1366'>
                                    <div className='vdp-gallery-tab wow reveal fadeInUp'>
                                        <Fancybox
                                            options={{
                                                Carousel: {
                                                    infinite: false,
                                                },
                                            }}
                                        >
                                            {isMobile ?
                                                <div className='row g-3'>
                                                    {vehicleData.gallery_images.slice(0, 3).map((v, i) => {
                                                        return v.map((w, j) => {
                                                            const uniqueKey = `${i}-${j}`;
                                                            return (
                                                                <div className='col-6' key={uniqueKey}>
                                                                    <div className='gallery-box'>
                                                                        <a
                                                                            data-fancybox="gallery_1"
                                                                            ref={i === 0 && j === 0 ? galleryRef : null}
                                                                            href={w}
                                                                            className='position-relative'
                                                                        >
                                                                            <img src={w} alt='thumb' onError={(e) => { e.target.src = getImages("vdp_top_coming_soon.webp") }} />
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            );
                                                        });
                                                    })}

                                                    <div className='col-12 text-center mt-4'>
                                                        <button type='button' className='photo-count'
                                                            onClick={openGallery}
                                                        ><img src={getImages('photo-camera-icon.png')} /> {vehicleData.gallery_images.flat().length}+</button>
                                                    </div>
                                                </div>
                                                : <Slider className="gallery-slider common-arrow" {...srpCarSlider}>
                                                    {vehicleData.gallery_images.map((v, i) => {
                                                        return (
                                                            <div className='item' key={i}>
                                                                {v.map((w, j) => {
                                                                    return (
                                                                        <div className='gallery-box mb-4' key={j}>
                                                                            <a data-fancybox="gallery" href={w} className='position-relative'>
                                                                                <img src={w} alt='thumb' />
                                                                            </a>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        );
                                                    })}
                                                </Slider>}
                                        </Fancybox>
                                    </div>
                                </div>
                            </section>
                        }
                        <section className='vdp-content-wrap'>
                            <div className='container mxw-1366'>
                                <div className='vdpa-block pt-5 row'>
                                    <div className='col-lg-4 order-lg-2 mb-3 mb-lg-0'>
                                        <div className='vdpa-box p-4'>
                                            <div className='md-title fw-500 mb-3 wow reveal fadeInUp'>Vehicle Info</div>
                                            <div className='vdpa-table'>
                                                <table className='w-100'>
                                                    <tbody>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Stock</th>
                                                            <td>{vehicleData.stockno}</td>
                                                        </tr>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>VIN</th>
                                                            <td className="text-nowrap">
                                                                <span className='position-relative copy-info'>
                                                                    <span className='copy_icon' onClick={handleCopy} style={{ cursor: 'pointer' }}></span>
                                                                    {tooltipVisible && <span className='copy-tooltip'>Copied!</span>}
                                                                </span>
                                                                {vehicleData.vin}
                                                            </td>
                                                        </tr>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Year</th>
                                                            <td>{vehicleData.year}</td>
                                                        </tr>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Make</th>
                                                            <td>{vehicleData.make}</td>
                                                        </tr>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Model</th>
                                                            <td>{vehicleData.model}</td>
                                                        </tr>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Trim</th>
                                                            <td>{vehicleData.trim}</td>
                                                        </tr>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Mileage</th>
                                                            <td>{numberFormatter(vehicleData.mileage, false, false)}</td>
                                                        </tr>
                                                        {/* <tr className='wow reveal fadeInUp'>
                                                        <th>Model Number</th>
                                                        <td>{vehicleData.model}</td>
                                                    </tr> */}
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Body Style</th>
                                                            <td>{vehicleData.body_style}</td>
                                                        </tr>
                                                        {/* <tr className='wow reveal fadeInUp'>
                                                        <th>Transmission</th>
                                                        <td></td>
                                                    </tr>
                                                    <tr className='wow reveal fadeInUp'>
                                                        <th>Cylinders</th>
                                                        <td></td>
                                                    </tr>
                                                    <tr className='wow reveal fadeInUp'>
                                                        <th>Fuel Type</th>
                                                        <td></td>
                                                    </tr> */}
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Exterior Color</th>
                                                            <td>{vehicleData.exterior_color}</td>
                                                        </tr>
                                                        <tr className='wow reveal fadeInUp'>
                                                            <th>Interior Color</th>
                                                            <td>{vehicleData.interior_color}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className='mt-md-4 mt-3 mb-2 d-flex align-items-center justify-content-between wow reveal fadeInUp'>
                                                <div className='text-center carfax-tag'>
                                                    <a href={'http://www.carfax.com/VehicleHistory/p/Report.cfx?partner=DVW_1&vin=' + vehicleData.vin} target="_blank">
                                                        <img src={getImages('carfax-tag-new.png')} alt='carfax' />
                                                    </a>
                                                </div>
                                                <div>
                                                    <button className='view-report-btn'>View Report</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-8' id="aboutVdp">
                                        <div className='vdpa-box vdpa-about-box h-100'>
                                            <h2 className='md-title text-uppercase mb-3 wow reveal fadeInUp'>About this Vehicle</h2>
                                            <p className='wow reveal fadeInUp'>
                                                {isExpanded ? <span dangerouslySetInnerHTML={renderHTML(vehicleData.description)} /> : <span dangerouslySetInnerHTML={renderHTML(shortText + '...')} />}
                                                <span
                                                    onClick={toggleReadMore}
                                                    style={{ color: '#fff', cursor: 'pointer', textDecoration: 'none' }}
                                                >
                                                    {isExpanded ? ' Read Less' : ' Read More'}
                                                </span>
                                            </p>
                                            <div id="gotAQuestion" ref={sectionRef} >
                                                <div className='gq-title mt-2 pt-5 mb-5 wow reveal fadeInUp'>Got a question? <a href="#" className='text-theme'>Call</a> or <a href="#" className='text-theme'>Chat</a> live with a sales representative</div>
                                                <Formik
                                                    // validationSchema={validationSchema}
                                                    initialValues={{
                                                        full_name: '',
                                                        email: '',
                                                        phone: '',
                                                        comment: '',
                                                        vin: vehicleData.stockno,
                                                        year: vehicleData.year,
                                                        make: vehicleData.make,
                                                        model: vehicleData.model,
                                                        trim: vehicleData.trim,
                                                        mileage: vehicleData.mileage,
                                                        exterior: vehicleData.exterior_color
                                                    }}
                                                    onSubmit={async (values, { resetForm }) => {
                                                        const token = await recaptchaRef.current.executeAsync();
                                                        console.log('reCAPTCHA token:', token);
                                                        recaptchaRef.current.reset(); // Reset after use
                                        
                                                        values.token = token;
                                                        
                                                        console.log(values);

                                                        const data = await submitContactForm(values);
                                                        
                                                        if (data.success) {
                                                            resetForm();
                                                            navigate("/thank-you");
                                                        } else
                                                            alert("There was a problem with your submission");
                                                    }}
                                                >
                                                    {({ values, setFieldValue, field, form }) => (
                                                        <Form className="custom-form vdp-contact-form" autoComplete="off" name="contact-form">
                                                            <Field type="hidden" name="vin" value={vehicleData.vin} />
                                                            <Field type="hidden" name="year" value={vehicleData.year} />
                                                            <Field type="hidden" name="make" value={vehicleData.make} />
                                                            <Field type="hidden" name="model" value={vehicleData.model} />
                                                            <Field type="hidden" name="trim" value={vehicleData.trim} />
                                                            <Field type="hidden" name="mileage" value={vehicleData.mileage} />
                                                            <Field type="hidden" name="exterior" value={vehicleData.exterior_color} />
                                                            <div className='row'>
                                                                <div className='col-md-6 wow reveal fadeInUp'>
                                                                    <div className='form-group mb-3'>
                                                                        <div className='d-flex align-items-center justify-content-between mb-2'>
                                                                            <div className='cs-label mb-0'>Full Name</div>
                                                                            <div className='cs-require'>* Required</div>
                                                                        </div>
                                                                        <Field
                                                                            type="text"
                                                                            name="full_name"
                                                                            className="form-control"
                                                                            required />
                                                                        <ErrorMessage name="full_name" component="div" className="text-danger" />
                                                                    </div>
                                                                    <div className='form-group mb-3'>
                                                                        <div className='d-flex align-items-center justify-content-between mb-2'>
                                                                            <div className='cs-label mb-0'>Email</div>
                                                                            <div className='cs-require'>* Required</div>
                                                                        </div>
                                                                        <Field
                                                                            type="text"
                                                                            name="email"
                                                                            className="form-control"
                                                                            required />
                                                                        <ErrorMessage name="email" component="div" className="text-danger" />
                                                                    </div>
                                                                    <div className='form-group mb-3'>
                                                                        <div className='cs-label mb-2'>Phone Number</div>
                                                                        <Field
                                                                            type="text"
                                                                            name="phone"
                                                                            className="form-control"
                                                                            required />
                                                                        <ErrorMessage name="phone" component="div" className="text-danger" />
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-6 wow reveal fadeInUp'>
                                                                    <div className='form-group mb-3'>
                                                                        <div className='cs-label mb-2'>Comments</div>
                                                                        <Field
                                                                            type="text"
                                                                            name="comment"
                                                                            className="form-control h-218"
                                                                            component="textarea" />
                                                                        <ErrorMessage name="comment" component="div" className="text-danger" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='row mt-3 justify-content-between about-action-flex wow reveal fadeInUp'>
                                                                <div className='col-md-6 text-end order-md-2'>
                                                                    <button className='transparent-btn text-uppercase w-230'>Send</button>
                                                                </div>
                                                                <div className='col-md-6 fb-contact-info'>
                                                                    <a href='tel:9549463000' className='d-inline-flex align-items-center phone-no-text mb-2'>
                                                                        <span className='fw-400 mnw-150'><span className='call-icon'><img src={getImages('call.png')} alt='call' /></span></span>
                                                                        <span className='ps-md-3 ps-2'>954-946-3000</span>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </Form>
                                                    )}
                                                </Formik>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </section>
                </>
                :
                <section className='vdp-wrap mnh-90vh'></section>
            }
        </>
    )
}

export default Vdp